import { useTranslation } from 'react-i18next';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { images } from '../../constants';
import { whyUsItems } from '../../data';
import './whyus.scss';

const whyUsKeys = ['excellence', 'talent', 'pricing', 'tailored', 'tamkeen'];

const CardObjW = ({ image, title, info }) => {
    return (
        <div className="CardObj-wu">
            <img className="wu__img" src={image} alt={title} />
            <img className="wu__blur" src={images.bgBlur} alt="" />
            <div>
                <h2>{title}</h2>
                <p>{info}</p>
            </div>
        </div>
    )
}

const Whyus = () => {
    const { t } = useTranslation();

    return (
        <>
        <div className="Whyus section">
            <h1>{t('whyUs.title')}</h1>
            <p>{t('whyUs.subtitle')}</p>
        </div>
            <div className="container">
        <div className="CardHolder-wu">
                    {whyUsItems.map((item, index) => (
                        <CardObjW
                            key={index}
                            title={t(`data.whyUs.${whyUsKeys[index]}.title`)}
                            image={images[item.imageKey]}
                            info={t(`data.whyUs.${whyUsKeys[index]}.info`)}
                        />
                    ))}
                </div>
                </div>
        </>
  )
}

export default Whyus;